// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import infoIcon from './info-icon.svg';

export function PixInfo(): Node {
  return (
    <Root>
      <IconWrapper>
        <Icon src={infoIcon} alt="info icon"/>
      </IconWrapper>
      <Info>
        Você poderá pagar com Pix no app do seu banco ou de sua carteira digital. A aprovação acontecerá em instantes.
      </Info>
    </Root>
  );
}

const Root = styled.div `
  background: ${props => props.theme.colors.new_primary[50]};
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 16px 20px 16px 16px;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  color: #fff;
`;

const IconWrapper = styled.div`
  background: #007ace;
  display: inline-block;
  margin-right: 16px;
  padding: 9px;
  border-radius: 14px;

  width: 38px;
  height: 38px;
`;

const Info = styled.div`
  font-size: 13px;
  line-height: 21px;
  color: ${props => props.theme.colors.neutral[900]};
  width: 100%;
  display: inline-block;
`;
